import { lazy, Suspense, useState, useEffect, FunctionComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import Contact1stdibsModalLazy from './Contact1stdibsModalLazy';

import styles from './Contact1stdibsLink.scss';

import { Contact1stdibsLink_viewer as ViewerType } from './__generated__/Contact1stdibsLink_viewer.graphql';

const TradeRepCircle = lazy(
    () =>
        import(
            /* webpackChunkName: "Contact1stdibsModalTradeRepCircle" */ 'dibs-sales-rep/exports/TradeRepCircle'
        )
);

type ReduxState = {
    relayVariables: {
        variables: {
            itemId: string;
        };
    };
};

type Contact1stdibsLinkProps = {
    hasUserId: boolean;
    hasRootPendingRefetch: boolean;
    isUserTypeTrade: boolean;
    viewer: ViewerType;
};

const Contact1stdibsLink: FunctionComponent<Contact1stdibsLinkProps> = ({
    hasUserId,
    hasRootPendingRefetch,
    isUserTypeTrade,
    viewer,
}) => {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const [didMount, setDidMount] = useState(false);
    useEffect(() => {
        setDidMount(true);
    }, []);
    const renderTradeCirlce = isUserTypeTrade && hasUserId && didMount && !hasRootPendingRefetch;

    return (
        <>
            <div className={styles.wrapper}>
                <button
                    className={styles.container}
                    onClick={() => {
                        setIsContactModalOpen(true);
                    }}
                >
                    {renderTradeCirlce ? (
                        <div className={styles.iconWrapper}>
                            <Suspense fallback={null}>
                                <TradeRepCircle theme="dark" viewer={viewer} />
                            </Suspense>
                        </div>
                    ) : null}
                    {/* element below is used as an anchor for `ContactTradeRepTooltip.tsx`, hence the ID */}
                    <div
                        className={styles.contact1stdibs}
                        data-tn="contact-1stdibs-link"
                        id="trade-spec"
                    >
                        <FormattedMessage
                            id="dbl.contact1stdibsLink.contact1stdibs"
                            defaultMessage="Contact 1stDibs"
                        />
                    </div>
                </button>
            </div>

            <Contact1stdibsModalLazy
                isOpen={isContactModalOpen}
                placement="globalNav"
                onClose={() => setIsContactModalOpen(false)}
            />
        </>
    );
};

export default createFragmentContainer(Contact1stdibsLink, {
    viewer: graphql`
        fragment Contact1stdibsLink_viewer on Viewer {
            ...TradeRepCircle_viewer @include(if: $hasTradeUserId) @defer
        }
    `,
});
